let matomo = {
	url: "//piwik.vliz.be/",
	tracker_id: "43"
};

matomo = {
	url: "//matomo.n4m5.nl/",
	tracker_id: "3"
};

export default matomo;